import React from 'react';

export const ValidationMessage = ({ error }) => {
   return !error ? null : <span className="field-validation-error">{error.message}</span>;
}